import React, { useEffect, useState } from 'react';
import API from '../api';

const AdminDashboard = () => {
  const [purchases, setPurchases] = useState([]);

  const fetchPurchases = async () => {
    try {
      const res = await API.get('/purchase/admin/all');
      setPurchases(res.data);
    } catch (err) {
      alert('Failed to load purchase data');
    }
  };

  const approvePurchase = async (id) => {
    try {
      await API.put(`/purchase/admin/approve/${id}`);
      fetchPurchases(); // reload
    } catch {
      alert('Approval failed');
    }
  };

  const rejectPurchase = async (id) => {
    try {
      await API.delete(`/purchase/admin/reject/${id}`);
      fetchPurchases(); // reload
    } catch {
      alert('Rejection failed');
    }
  };

  useEffect(() => {
    fetchPurchases();
  }, []);

  return (
    <div>
      <h2>Admin Dashboard – Purchase Requests</h2>
      {purchases.length === 0 ? (
        <p>No purchase requests found.</p>
      ) : (
        <table border="1" cellPadding="10">
          <thead>
            <tr>
              <th>User</th>
              <th>Email</th>
              <th>Course</th>
              <th>Status</th>
              <th>Purchase Date</th>
              <th>Expiry</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {purchases.map((p) => (
              <tr key={p.id}>
                <td>{p.user_name}</td>
                <td>{p.email}</td>
                <td>{p.course_title}</td>
                <td>{p.status}</td>
                <td>{p.purchase_date || '-'}</td>
                <td>{p.expiry_date || '-'}</td>
                <td>
                  {p.status === 'pending' && (
                    <>
                      <button onClick={() => approvePurchase(p.id)}>Approve</button>{' '}
                      <button onClick={() => rejectPurchase(p.id)}>Reject</button>
                    </>
                  )}
                  {p.status === 'approved' && <span>✔️</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminDashboard;
